import { createSlice } from '@reduxjs/toolkit';

import { getDentalPlans, getDentalQuotePlans } from './dentalConfiguration.actions';

const initialState = {
  dentalPlans: [],
  dentalQuotePlans: [],
  isLoadingDentalQuotePlans: false,
  isLoadingDentalPlans: false,

  // ISSUER
  issuerDentalPlans: [],
  isLoadingIssuerDentalPlans: false,
  isLoadingUpdateDentalOffer: false,
};

const dentalConfigurationSlice = createSlice({
  name: 'dentalConfiguration',
  initialState,
  reducers: {
    setDentalPlans: (state, action) => {
      state.dentalPlans = action.payload;
    },
    setDentalQuotePlans: (state, action) => {
      state.dentalQuotePlans = action.payload;
    },

    setIssuerDentalPlans: (state, action) => {
      state.issuerDentalPlans = action.payload;
    },

    clearDentalConfigurationState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getDentalQuotePlans.pending, (state) => {
      state.isLoadingDentalQuotePlans = true;
    });
    builder.addCase(getDentalQuotePlans.fulfilled, (state, action) => {
      state.dentalQuotePlans = action.payload;
      state.isLoadingDentalQuotePlans = false;
    });
    builder.addCase(getDentalQuotePlans.rejected, (state) => {
      state.isLoadingDentalQuotePlans = false;
    });

    builder.addCase(getDentalPlans.pending, (state) => {
      state.isLoadingDentalPlans = true;
    });
    builder.addCase(getDentalPlans.fulfilled, (state, action) => {
      state.dentalPlans = action.payload;
      state.isLoadingDentalPlans = false;
    });
    builder.addCase(getDentalPlans.rejected, (state) => {
      state.isLoadingDentalPlans = false;
    });
  },
});

export const {
  setDentalPlans,
  setDentalQuotePlans,
  setIssuerDentalPlans,
  clearDentalConfigurationState,
} = dentalConfigurationSlice.actions;

export default dentalConfigurationSlice.reducer;
